/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

export enum VariableKey {
  CURRENT_SUBSIDIARY = 'current_subsidiary',
  ROOT_SUBSIDIARY = 'root_subsidiary',
  PERIOD = 'period',
  DURATION = 'duration',
}

export type VariableMap = Record<VariableKey, string>;

export interface VariableDefinition {
  key: VariableKey;
  label: string;
  icon: string;
  description: string;
}
